import { useCallback, useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";

//interfaces
import { PersonaPrueba } from "../../../../interfaces/PersonaPruebaInterface";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";
import SuccessMessage from "../../../Mensajes/SuccessMessage";
import ServerMessage from "../../../Mensajes/ServerMessage";

/**
 * UusarioEdit Component
 * @description: Componente que permite editar un verificacion.
 * @date 6/12/2022.
 * @param Props Ninguno
 * @returns JSX de la tabla de verificacions.
 */

const PersonaPruebaEdit = () => {
  const { idPersonaPrueba } = useParams();
  const { sendRequest, error, setError, serverMessage, setServerMessage } =
    useFetch();
  const [personaPrueba, setPersonaPrueba] = useState<PersonaPrueba>();
  const [show, setShow] = useState(false);

  //Variables de formulario
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      nombre: personaPrueba?.nombre,
    },
  });

  //Función que trata el detalle de verificacion.
  const transformData = useCallback(
    (variable: any) => {
      setPersonaPrueba(variable.data);
      reset(variable.data);
    },
    [reset]
  );

  //Se recibe el verificacion a editar
  useEffect(() => {
    sendRequest(
      {
        url: `/persona_prueba/${idPersonaPrueba}`,
      },
      transformData
    );
  }, [idPersonaPrueba, sendRequest, transformData]);

  //Función que solicita la edición del verificacion
  const updateVerificacion = (data: any) => {
    sendRequest(
      {
        url: `/persona_prueba/${idPersonaPrueba}`,
        method: "PATCH",
        body: data,
      },
      (variable: any) => {
        setShow(true);
      }
    );
  };

  return (
    <Container>
      <h2>Edición de la persona en prueba {idPersonaPrueba}</h2>
      {/** Alerta de guardado */}
      {show && (
        <SuccessMessage
          header="Persona en pruebas actualizada"
          body="La persona en pruebas ha sido actualizada de manera correcta."
          onCloseHandler={() => setShow(false)}
        />
      )}
      {/** Error del servidor */}
      {serverMessage && (
        <ServerMessage
          message={serverMessage}
          onCloseHandler={() => setServerMessage(undefined)}
        />
      )}
      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      {/** Formulario */}
      <Form onSubmit={handleSubmit(updateVerificacion)}>
        <Row className="mb-3">
          <Form.Group as={Col} md="12" className="mb-3">
            <Form.Label>Nombre completo</Form.Label>
            <Controller
              name="nombre"
              control={control}
              rules={{
                required: true,
                maxLength: 50,
              }}
              render={({ field }) => {
                return (
                  <Form.Control
                    {...field}
                    onChange={(e) =>
                      field.onChange(e.target.value.toUpperCase())
                    }
                  />
                );
              }}
            />
            {errors.nombre && (
              <Form.Text style={{ color: "red" }}>
                El nombre es obligatorio y no puede ser mayor a 50 caracteres.
              </Form.Text>
            )}
          </Form.Group>
        </Row>

        <Button
          style={{
            backgroundColor: "#21618C",
            borderColor: "white",
          }}
          type="submit"
        >
          Guardar cambios
        </Button>
      </Form>
    </Container>
  );
};

export default PersonaPruebaEdit;
